import './Card.css';
import { Link } from 'react-router-dom';

type Props = {
    children: React.ReactNode;
    elevation?: number;
    className?: string;
    link?: string;
    onClick?: () => void;
};

// Card component working with elevation class - shadow enlargement according to the elevation level. (illusion of elevation)
const Card = ({ children, elevation = 1, className, link, onClick }: Props) => {
    const classNames = `card elevation-${elevation} ${className}`;

    return link ? (
        <Link to={link} className={classNames}>
            {children}
        </Link>
    ) : (
        <div className={classNames} onClick={onClick}> 
            {children}
        </div>
    );
};

export default Card;
